/*
 * @Author: 李才人
 * @Date: 2021-07-29 16:42:12
 * @LastEditors: 李才人
 * @LastEditTime: 2021-08-09 17:50:18
 * @FilePath: \m_saas_business_admin\src\modules\operationTools\config\questionnaire.ts
 * @Description:
 */
export var IQuestionComonentType;
(function (IQuestionComonentType) {
  IQuestionComonentType[IQuestionComonentType["Question"] = 0] = "Question";
  IQuestionComonentType[IQuestionComonentType["Decoration"] = 1] = "Decoration";
})(IQuestionComonentType || (IQuestionComonentType = {}));
export var DecorationType;
(function (DecorationType) {
  DecorationType["picture"] = "5";
  DecorationType["text"] = "8";
  DecorationType["empty"] = "-1";
})(DecorationType || (DecorationType = {}));
export var QuestionType;
(function (QuestionType) {
  QuestionType["empty"] = "-1";
  QuestionType["singleChoice"] = "1";
  QuestionType["multipleChoice"] = "2";
  QuestionType["fillIn"] = "3";
  QuestionType["cascade"] = "4";
  QuestionType["uploadAddon"] = "6";
  QuestionType["phoneNumber"] = "7";
})(QuestionType || (QuestionType = {}));
export const questionData = [{
  type: IQuestionComonentType.Question,
  name: "单选题",
  title: "请选择以下选项",
  componentName: QuestionType.singleChoice,
  icon: "",
  data: {
    required: 1,
    optionContentType: "TEXT",
    optionsList: [{
      value: "1",
      content: "选项1"
    }, {
      value: "2",
      content: "选项2"
    }]
  }
}, {
  type: IQuestionComonentType.Question,
  name: "多选题",
  title: "请选择以下选项",
  componentName: QuestionType.multipleChoice,
  icon: "",
  data: {
    required: 1,
    optionContentType: "TEXT",
    optionsList: [{
      value: "1",
      content: "选项1"
    }, {
      value: "2",
      content: "选项2"
    }]
  }
}, {
  type: IQuestionComonentType.Question,
  name: "填空题",
  title: "请填写本项内容",
  componentName: QuestionType.fillIn,
  icon: "",
  data: {
    title: "",
    required: 1,
    content: ""
  }
},
// {
//   type: IQuestionComonentType.Question,
//   name: "级联题",
//   title: "请选择以下选项",
//   componentName: QuestionType.cascade,
//   icon: "",
//   data: {
//     required: 1,
//     title: "",
//     optionsList: [],
//   } as ISelectedoptionsData,
// },
{
  type: IQuestionComonentType.Question,
  name: "手机号码",
  title: "您的手机号码是？",
  componentName: QuestionType.phoneNumber,
  icon: "",
  data: {
    phoneNumber: "",
    required: 1
  }
}, {
  type: IQuestionComonentType.Question,
  name: "上传附件",
  title: "请上传附件",
  componentName: QuestionType.uploadAddon,
  icon: "",
  data: {
    required: 1,
    uploadLimitCount: 1,
    title: ""
  }
}];
export const testData = [{
  type: IQuestionComonentType.Question,
  name: "单选题",
  title: "请选择以下选项",
  componentName: QuestionType.singleChoice,
  icon: "",
  data: {
    required: 1,
    itemScore: 0,
    optionContentType: "TEXT",
    optionsList: [{
      value: "1",
      content: "选项1",
      rightOption: true
    }, {
      value: "2",
      content: "选项2",
      rightOption: false
    }]
  }
}, {
  type: IQuestionComonentType.Question,
  name: "多选题",
  title: "请选择以下选项",
  componentName: QuestionType.multipleChoice,
  icon: "",
  data: {
    required: 1,
    itemScore: 0,
    optionContentType: "TEXT",
    optionsList: [{
      value: "1",
      content: "选项1",
      rightOption: true
    }, {
      value: "2",
      content: "选项2",
      rightOption: true
    }]
  }
}, {
  type: IQuestionComonentType.Question,
  name: "填空题",
  title: "请填写本项内容",
  componentName: QuestionType.fillIn,
  icon: "",
  data: {
    title: "",
    required: 1,
    content: "",
    itemScore: 0,
    rightText: "",
    scoreRule: "INCLUDE"
  }
}];
export const decorationData = [{
  type: IQuestionComonentType.Decoration,
  name: "图片",
  title: "请上传图片",
  componentName: DecorationType.picture,
  icon: "",
  data: {
    url: "",
    number: 0
  }
}, {
  type: IQuestionComonentType.Decoration,
  name: "文字",
  title: "请填写文字",
  componentName: DecorationType.text,
  icon: "",
  data: {
    text: ""
  }
}];